<div [hidden]="!downloading" class="page-loader text-center">
  <div class="loader"></div>
</div>
<div class="container">
  <div class="row">
    <div class="calendar">
      <div class="calendar__header row px-0">
        <div class="calendar__header-left px-0">
          <div class="d-flex align-items-center justify-content-start gap-2 gap-sm-4">
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button
              (viewDateChange)="fetchEvents()"
              [(viewDate)]="viewDate"
              [view]="view"
              class="btn btn--calendar-nav btn--calendar-nav-previous"
              coreCalendarPreviousView
              [core-analytics]="{ action: 'previous', block }"
              type="button"></button>
            <h4 [innerText]="viewDate | calendarDate: view + 'ViewTitle' : 'en'" class="calendar-date"></h4>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button
              (viewDateChange)="fetchEvents()"
              [(viewDate)]="viewDate"
              [view]="view"
              class="btn btn--calendar-nav"
              coreCalendarNextView
              [core-analytics]="{ action: 'next', block }"
              type="button"></button>
            <div
              (viewDateChange)="fetchEvents()"
              [(viewDate)]="viewDate"
              [innerText]="'Today' | translate"
              class="btn btn-today btn-outline-secondary d-none d-lg-flex"
              coreCalendarToday></div>
          </div>
        </div>
        <div class="calendar__header-right px-0">
          <!-- <button
          (click)="setView(CalendarView.Month)"
          [class.active]="view === CalendarView.Month"
          [innerText]="'Month' | translate"
          [core-analytics]="{ action: 'month-view', block }"
          class="btn btn--calendar-view"
          type="button"
        ></button> -->
        </div>
      </div>
      <hr class="calendar__border" />
      <div class="calendar__inner">
        <div
          #calendarMain
          [ngClass]="{
            'calendar__main--off-canvas': toggleCalendarOffCanvas,
            'custom-month-event-view-on': isCustomMonthEventView,
          }"
          class="calendar__main">
          <div class="card mb-0">
            <div class="card-body">
              @if (events$ | async; as events) {
                <div>
                  <core-calendar-month-view
                    (dayClicked)="dayClicked($event.day)"
                    (eventClicked)="handleEvent('Clicked', $event.event)"
                    [cellTemplate]="customCellTemplate"
                    [events]="events"
                    [refresh]="refresh"
                    [viewDate]="viewDate"
                    [weekStartsOn]="0"
                    [activeDayIsOpen]="activeDayIsOpen">
                  </core-calendar-month-view>
                </div>
              } @else {
                <div class="page-loader block text-center">
                  <div class="loader"></div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template
  #customCellTemplate
  let-day="day"
  let-eventClicked="eventClicked"
  let-highlightDay="highlightDay"
  let-locale="locale"
  let-trackByEventId="trackByEventId"
  let-unhighlightDay="unhighlightDay"
  let-validateDrag="validateDrag">
  <div class="cal-cell-wrapper">
    <div class="cal-cell-top">
      @if (day.badgeTotal > 0) {
        <span [innerText]="day.badgeTotal" class="cal-day-badge"></span>
      }
      <span [innerText]="day.date | calendarDate: 'monthViewDayNumber' : locale || 'en'" class="cal-day-number"></span>
    </div>
    @if (day.events.length > 0) {
      <div class="cal-events">
        <!-- Custom month event view with event title showing inside month day cell -->
        @if (isCustomMonthEventView) {
          @for (event of $any(day.events); track event.id ?? $index; let isLast = $last; let eventIndex = $index) {
            @if (eventIndex < 2 || isExpanded(day)) {
              <div
                (coreCalendarClick)="eventClicked.emit({ event: event, sourceEvent: $event })"
                [attr.aria-hidden]="{} | calendarA11y: 'hideMonthCellEvents'"
                [class.cal-draggable]="event.draggable"
                [dragAxis]="{ x: event.draggable, y: event.draggable }"
                [dropData]="{ event: event, draggedFrom: day }"
                [ngClass]="event?.cssClass"
                [touchStartLongPress]="{ delay: 300, delta: 30 }"
                [validateDrag]="validateDrag"
                coreCalendarDraggable
                dragActiveClass="cal-drag-active"
                class="custom-month-event cal-event-colour cal-event-colour--{{ event.type || 'default' }}">
                <p class="custom-month-event__time">
                  {{
                    event.allDay ? 'All Day' : (event.start | date: 'shortTime') + '–' + (event.end | date: 'shortTime')
                  }}
                </p>
                <span [innerText]="event.title || '' | translate" class="custom-month-event__title mb-1"></span>
              </div>
            }
            <!-- Show 'View All' button if more than 2 events are present -->
            @if (isLast && day.events.length > 2 && !isExpanded(day) && !isCustomMonthEventViewForMobile) {
              <button
                (click)="expandDay(day)"
                class="badge btn-default btn--calendar-event-view-more w-100 d-flex justify-content-between">
                <span>View <span [innerText]="day.events.length - 2"></span> more </span>
              </button>
            }
          }
        }
      </div>
    }
  </div>
</ng-template>

<ng-template
  #popTemplate
  let-color="color"
  let-description="description"
  let-end="end"
  let-id="id"
  let-start="start"
  let-title="title">
  <div class="d-flex">
    <div>
      <div class="d-flex">
        <span
          [ngStyle]="{
            'background-color': 'var(--color-calendar-view-btn-hover)',
            'margin-top': '7px',
          }"
          class="badge-dot"></span>
        <div class="ms-2">
          <h5 [innerText]="title || '' | translate" class="mx-1"></h5>
          <div class="text-muted">
            <span [innerText]="start | date"></span>
            @if (end) {
              <span class="mx-1">~<br /></span>
            }
            @if (end) {
              <span [innerText]="end | date"></span>
            }
          </div>
          @if (description) {
            <p [innerText]="description" class="mt-3 mb-0"></p>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Event Modal -->
<ng-template #eventModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{ modalData?.event?.title || '' | translate }}
    </h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeEventModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="d-flex">
      <div>
        <div class="d-flex">
          <span
            [ngStyle]="{
              'background-color': 'var(--color-calendar-view-btn-hover)',
              'margin-top': '7px',
            }"
            class="badge-dot"></span>
          <div class="ms-2">
            <div [innerHtml]="modalData?.event?.description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
